import React from "react";
import { motion } from "framer-motion";

interface LogoCircuitProps {
  size?: "sm" | "md" | "lg" | "xl";
  animate?: boolean;
  showText?: boolean;
  className?: string;
}

// Responsive ASCII block art
const ASCII_SM = `███████╗███████╗██████╗  ██████╗     ██████╗  ██████╗ ██╗███╗   ██╗████████╗
╚══███╔╝██╔════╝██╔══██╗██╔═══██╗    ██╔══██╗██╔═══██╗██║████╗  ██║╚══██╔══╝
  ███╔╝ █████╗  ██████╔╝██║   ██║    ██████╔╝██║   ██║██║██╔██╗ ██║   ██║
 ███╔╝  ██╔══╝  ██╔══██╗██║   ██║    ██╔═══╝ ██║   ██║██║██║╚██╗██║   ██║
███████╗███████╗██║  ██║╚██████╔╝    ██║     ╚██████╔╝██║██║ ╚████║   ██║
╚══════╝╚══════╝╚═╝  ╚═╝ ╚═════╝     ╚═╝      ╚═════╝ ╚═╝╚═╝  ╚═══╝   ╚═╝`;

const ASCII_MD = `███████╗███████╗██████╗  ██████╗     ██████╗  ██████╗ ██╗███╗   ██╗████████╗    ██████╗  ██████╗ ███╗   ███╗ █████╗ ██╗███╗   ██╗███████╗
╚══███╔╝██╔════╝██╔══██╗██╔═══██╗    ██╔══██╗██╔═══██╗██║████╗  ██║╚══██╔══╝    ██╔══██╗██╔═══██╗████╗ ████║██╔══██╗██║████╗  ██║██╔════╝
  ███╔╝ █████╗  ██████╔╝██║   ██║    ██████╔╝██║   ██║██║██╔██╗ ██║   ██║       ██║  ██║██║   ██║██╔████╔██║███████║██║██╔██╗ ██║███████╗
 ███╔╝  ██╔══╝  ██╔══██╗██║   ██║    ██╔═══╝ ██║   ██║██║██║╚██╗██║   ██║       ██║  ██║██║   ██║██║╚██╔╝██║██╔══██║██║██║╚██╗██║╚════██║
███████╗███████╗██║  ██║╚██████╔╝    ██║     ╚██████╔╝██║██║ ╚████║   ██║       ██████╔╝╚██████╔╝██║ ╚═╝ ██║██║  ██║██║██║ ╚████║███████║
╚══════╝╚══════╝╚═╝  ╚═╝ ╚═════╝     ╚═╝      ╚═════╝ ╚═╝╚═╝  ╚═══╝   ╚═╝       ╚═════╝  ╚═════╝ ╚═╝     ╚═╝╚═╝  ╚═╝╚═╝╚═╝  ╚═══╝╚══════╝`;

const ASCII_LG = `███████╗███████╗██████╗  ██████╗     ██████╗  ██████╗ ██╗███╗   ██╗████████╗
╚══███╔╝██╔════╝██╔══██╗██╔═══██╗    ██╔══██╗██╔═══██╗██║████╗  ██║╚══██╔══╝
  ███╔╝ █████╗  ██████╔╝██║   ██║    ██████╔╝██║   ██║██║██╔██╗ ██║   ██║
 ███╔╝  ██╔══╝  ██╔══██╗██║   ██║    ██╔═══╝ ██║   ██║██║██║╚██╗██║   ██║
███████╗███████╗██║  ██║╚██████╔╝    ██║     ╚██████╔╝██║██║ ╚████║   ██║
╚══════╝╚══════╝╚═╝  ╚═╝ ╚═════╝     ╚═╝      ╚═════╝ ╚═╝╚═╝  ╚═══╝   ╚═╝
██████╗  ██████╗ ███╗   ███╗ █████╗ ██╗███╗   ██╗███████╗
██╔══██╗██╔═══██╗████╗ ████║██╔══██╗██║████╗  ██║██╔════╝
██║  ██║██║   ██║██╔████╔██║███████║██║██╔██╗ ██║███████╗
██║  ██║██║   ██║██║╚██╔╝██║██╔══██║██║██║╚██╗██║╚════██║
██████╔╝╚██████╔╝██║ ╚═╝ ██║██║  ██║██║██║ ╚████║███████║
╚═════╝  ╚═════╝ ╚═╝     ╚═╝╚═╝  ╚═╝╚═╝╚═╝  ╚═══╝╚══════╝`;

const ASCII_XL = `███████╗███████╗██████╗  ██████╗     ██████╗  ██████╗ ██╗███╗   ██╗████████╗
╚══███╔╝██╔════╝██╔══██╗██╔═══██╗    ██╔══██╗██╔═══██╗██║████╗  ██║╚══██╔══╝
  ███╔╝ █████╗  ██████╔╝██║   ██║    ██████╔╝██║   ██║██║██╔██╗ ██║   ██║
 ███╔╝  ██╔══╝  ██╔══██╗██║   ██║    ██╔═══╝ ██║   ██║██║██║╚██╗██║   ██║
███████╗███████╗██║  ██║╚██████╔╝    ██║     ╚██████╔╝██║██║ ╚████║   ██║
╚══════╝╚══════╝╚═╝  ╚═╝ ╚═════╝     ╚═╝      ╚═════╝ ╚═╝╚═╝  ╚═══╝   ╚═╝
██████╗  ██████╗ ███╗   ███╗ █████╗ ██╗███╗   ██╗███████╗
██╔══██╗██╔═══██╗████╗ ████║██╔══██╗██║████╗  ██║██╔════╝
██║  ██║██║   ██║██╔████╔██║███████║██║██╔██╗ ██║███████╗
██║  ██║██║   ██║██║╚██╔╝██║██╔══██║██║██║╚██╗██║╚════██║
██████╔╝╚██████╔╝██║ ╚═╝ ██║██║  ██║██║██║ ╚████║███████║
╚═════╝  ╚═════╝ ╚═╝     ╚═╝╚═╝  ╚═╝╚═╝╚═╝  ╚═══╝╚══════╝`;

/**
 * CIRCUIT BOARD LOGO with ASCII text
 * PCB-style design with traces leading to a central processor
 * Plus responsive ASCII block art text
 */
const LogoCircuit: React.FC<LogoCircuitProps> = ({
  size = "md",
  animate = true,
  showText = true,
  className = "",
}) => {
  const sizes = {
    sm: { container: "w-8 h-8", text: "text-[4px]", icon: 32, ascii: ASCII_SM },
    md: { container: "w-12 h-12", text: "text-[5px]", icon: 48, ascii: ASCII_MD },
    lg: { container: "w-16 h-16", text: "text-[6px]", icon: 64, ascii: ASCII_LG },
    xl: { container: "w-24 h-24", text: "text-[8px]", icon: 96, ascii: ASCII_XL },
  };

  const config = sizes[size];
  const s = config.icon;
  const cx = s / 2;
  const cy = s / 2;

  // Circuit trace paths
  const traces = [
    // Top traces
    { path: `M ${cx} ${s * 0.08} L ${cx} ${s * 0.25}`, delay: 0 },
    { path: `M ${s * 0.3} ${s * 0.08} L ${s * 0.3} ${s * 0.2} L ${s * 0.35} ${s * 0.25}`, delay: 0.1 },
    { path: `M ${s * 0.7} ${s * 0.08} L ${s * 0.7} ${s * 0.2} L ${s * 0.65} ${s * 0.25}`, delay: 0.1 },
    // Right traces
    { path: `M ${s * 0.92} ${cy} L ${s * 0.75} ${cy}`, delay: 0.2 },
    { path: `M ${s * 0.92} ${s * 0.35} L ${s * 0.8} ${s * 0.35} L ${s * 0.75} ${s * 0.4}`, delay: 0.25 },
    { path: `M ${s * 0.92} ${s * 0.65} L ${s * 0.8} ${s * 0.65} L ${s * 0.75} ${s * 0.6}`, delay: 0.25 },
    // Bottom traces
    { path: `M ${cx} ${s * 0.92} L ${cx} ${s * 0.75}`, delay: 0.3 },
    { path: `M ${s * 0.3} ${s * 0.92} L ${s * 0.3} ${s * 0.8} L ${s * 0.35} ${s * 0.75}`, delay: 0.35 },
    { path: `M ${s * 0.7} ${s * 0.92} L ${s * 0.7} ${s * 0.8} L ${s * 0.65} ${s * 0.75}`, delay: 0.35 },
    // Left traces
    { path: `M ${s * 0.08} ${cy} L ${s * 0.25} ${cy}`, delay: 0.4 },
    { path: `M ${s * 0.08} ${s * 0.35} L ${s * 0.2} ${s * 0.35} L ${s * 0.25} ${s * 0.4}`, delay: 0.45 },
    { path: `M ${s * 0.08} ${s * 0.65} L ${s * 0.2} ${s * 0.65} L ${s * 0.25} ${s * 0.6}`, delay: 0.45 },
  ];

  // Node positions (solder points)
  const nodes = [
    { x: cx, y: s * 0.08 },
    { x: s * 0.3, y: s * 0.08 },
    { x: s * 0.7, y: s * 0.08 },
    { x: s * 0.92, y: cy },
    { x: s * 0.92, y: s * 0.35 },
    { x: s * 0.92, y: s * 0.65 },
    { x: cx, y: s * 0.92 },
    { x: s * 0.3, y: s * 0.92 },
    { x: s * 0.7, y: s * 0.92 },
    { x: s * 0.08, y: cy },
    { x: s * 0.08, y: s * 0.35 },
    { x: s * 0.08, y: s * 0.65 },
  ];

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className={`${config.container} relative`}>
        <svg
          viewBox={`0 0 ${s} ${s}`}
          className="w-full h-full"
          style={{ filter: "drop-shadow(0 0 8px rgba(34, 197, 94, 0.5))" }}
        >
          {/* Background grid (PCB substrate) */}
          <defs>
            <pattern id="pcbGrid" width={s * 0.05} height={s * 0.05} patternUnits="userSpaceOnUse">
              <circle cx={s * 0.025} cy={s * 0.025} r={0.5} fill="#0f3d1c" opacity={0.5} />
            </pattern>
          </defs>
          <rect x={0} y={0} width={s} height={s} fill="url(#pcbGrid)" />

          {/* Outer border */}
          <motion.rect
            x={s * 0.03}
            y={s * 0.03}
            width={s * 0.94}
            height={s * 0.94}
            fill="none"
            stroke="#22c55e"
            strokeWidth={1}
            rx={s * 0.02}
            initial={animate ? { pathLength: 0 } : {}}
            animate={{ pathLength: 1 }}
            transition={{ duration: 1 }}
          />

          {/* Circuit traces */}
          {traces.map((trace, i) => (
            <motion.path
              key={i}
              d={trace.path}
              fill="none"
              stroke="#22c55e"
              strokeWidth={s * 0.025}
              strokeLinecap="round"
              strokeLinejoin="round"
              initial={animate ? { pathLength: 0 } : {}}
              animate={{ pathLength: 1 }}
              transition={{ duration: 0.5, delay: trace.delay }}
            />
          ))}

          {/* Data flow animation along traces */}
          {animate &&
            traces.map((trace, i) => (
              <motion.circle
                key={`flow-${i}`}
                r={s * 0.015}
                fill="#4ade80"
                initial={{ offsetDistance: "0%" }}
                animate={{ offsetDistance: "100%" }}
                transition={{
                  duration: 1,
                  delay: trace.delay + 0.5,
                  repeat: Infinity,
                  repeatDelay: 2,
                }}
                style={{
                  offsetPath: `path("${trace.path}")`,
                }}
              />
            ))}

          {/* Solder nodes */}
          {nodes.map((node, i) => (
            <motion.g key={i}>
              <circle cx={node.x} cy={node.y} r={s * 0.025} fill="#0d2818" stroke="#22c55e" strokeWidth={1} />
              <motion.circle
                cx={node.x}
                cy={node.y}
                r={s * 0.012}
                fill="#4ade80"
                initial={animate ? { scale: 0 } : {}}
                animate={animate ? { scale: [1, 1.3, 1], opacity: [1, 0.6, 1] } : { scale: 1 }}
                transition={{
                  duration: 1.5,
                  delay: i * 0.1,
                  repeat: animate ? Infinity : 0,
                }}
              />
            </motion.g>
          ))}

          {/* Central processor chip */}
          <motion.rect
            x={s * 0.25}
            y={s * 0.25}
            width={s * 0.5}
            height={s * 0.5}
            fill="#0d2818"
            stroke="#22c55e"
            strokeWidth={2}
            rx={s * 0.02}
            initial={animate ? { scale: 0 } : {}}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5, delay: 0.5 }}
          />

          {/* Chip inner detail */}
          <motion.rect
            x={s * 0.3}
            y={s * 0.3}
            width={s * 0.4}
            height={s * 0.4}
            fill="none"
            stroke="#166534"
            strokeWidth={1}
            rx={s * 0.01}
            initial={animate ? { opacity: 0 } : {}}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8 }}
          />

          {/* Zero Point text on chip - larger ZP */}
          <motion.text
            x={cx}
            y={cy}
            textAnchor="middle"
            dominantBaseline="central"
            fill="#4ade80"
            fontSize={s * 0.22}
            fontWeight="bold"
            fontFamily="monospace"
            initial={animate ? { opacity: 0 } : {}}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          >
            ZP
          </motion.text>

          {/* Activity LED */}
          <motion.circle
            cx={s * 0.35}
            cy={s * 0.35}
            r={s * 0.02}
            fill="#22c55e"
            animate={animate ? { opacity: [1, 0.3, 1] } : {}}
            transition={{ duration: 0.5, repeat: Infinity }}
          />

          {/* Pin labels */}
          <motion.g
            initial={animate ? { opacity: 0 } : {}}
            animate={{ opacity: 0.4 }}
            transition={{ delay: 1.2 }}
          >
            <text x={cx} y={s * 0.2} textAnchor="middle" fill="#166534" fontSize={s * 0.035} fontFamily="monospace">
              VCC
            </text>
            <text x={cx} y={s * 0.83} textAnchor="middle" fill="#166534" fontSize={s * 0.035} fontFamily="monospace">
              GND
            </text>
            <text x={s * 0.2} y={cy + s * 0.01} textAnchor="middle" fill="#166534" fontSize={s * 0.035} fontFamily="monospace">
              IN
            </text>
            <text x={s * 0.8} y={cy + s * 0.01} textAnchor="middle" fill="#166534" fontSize={s * 0.035} fontFamily="monospace">
              OUT
            </text>
          </motion.g>
        </svg>
      </div>

      {showText && (
        <motion.pre
          initial={animate ? { opacity: 0, x: -10 } : {}}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.3, duration: 0.5 }}
          className={`${config.text} leading-none text-green-500 font-mono`}
          style={{
            textShadow: "0 0 10px rgba(34, 197, 94, 0.8)",
          }}
        >
          {config.ascii}
        </motion.pre>
      )}
    </div>
  );
};

export default LogoCircuit;
